/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import { array, object, bool, string } from "prop-types";
import get from "lodash/get";
import { getStoriesFromCollections } from "../../utils/collection";
import { DfpComponent } from "../../ads/dfp-component";
import { OtherStory } from "./OtherStory";
import CollectionTitle from "../../atoms/CollectionTitle";
import { RowSeparator } from "../../atoms/RowSeparator";

import "./three-col-eighteen-stories.m.css";

const Column = ({
  collection,
  showColumnSeparator,
  showStorySeparator,
  showTimestamp,
  showReadTime,
  showColumnTitle,
  sectionSlug,
  enableSponsorAd,
  sponsorAdDetails,
}) => {
  const stories = getStoriesFromCollections(collection, 4);
  return (
    <div styleName="column" style={{ border: showColumnSeparator || "none" }}>
      {showColumnTitle && (
        <div styleName="row-title">
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
          />
        </div>
      )}

      {stories.map((story) => {
        return (
          <OtherStory
            story={story}
            key={story.id}
            showStorySeparator={showStorySeparator}
            showTimestamp={showTimestamp}
            showReadTime={showReadTime}
            sectionSlug={sectionSlug}
          />
        );
      })}
    </div>
  );
};

Column.propTypes = {
  collection: object,
  showStorySeparator: bool,
  showColumnSeparator: bool,
  showTimestamp: bool,
  showReadTime: bool,
  showColumnTitle: bool,
  sectionSlug: string,
};

export function ThreeColEighteenStories({ collection, stories, extraProp = "" }) {
  const {
    show_timestamp,
    show_read_time,
    show_row_title,
    show_column_separator,
    show_row_separator,
    show_story_separator,
    show_row_ad_unit_bottom,
    enable_sponsor_ad,
    sponsor_ad_details,
  } = get(collection, ["associated-metadata"], {});
  const filteredCollection = get(collection, ["items"], [])
    .slice(0, 3)
    .map((collections) => {
      return collections.type === "collection" ? collections : [];
    });

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  return (
    <div className="row-component">
      <div styleName="three-col-eighteen-stories">
        <div styleName="columns">
          {filteredCollection.map((item) => (
            <Column
              collection={item}
              key={item.id}
              showTimestamp={show_timestamp}
              showReadTime={show_read_time}
              showColumnTitle={show_row_title}
              enableSponsorAd={enable_sponsor_ad}
              sponsorAdDetails={sponsor_ad_details}
              showStorySeparator={show_story_separator}
              showColumnSeparator={show_column_separator}
              sectionSlug={sectionSlug}
            />
          ))}
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}

ThreeColEighteenStories.propTypes = {
  collection: object,
  stories: array,
  extraProp: string,
};

ThreeColEighteenStories.storyLimit = 18;
